import { render, staticRenderFns } from "./HomeTabBar.vue?vue&type=template&id=13a4e70c&scoped=true&"
import script from "./HomeTabBar.vue?vue&type=script&lang=js&"
export * from "./HomeTabBar.vue?vue&type=script&lang=js&"
import style0 from "./HomeTabBar.vue?vue&type=style&index=0&id=13a4e70c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a4e70c",
  null
  
)

export default component.exports